module.exports = __webpack_public_path__ + "static/placehodle.e8d3a4e6.png";